import { render, staticRenderFns } from "./informationDetailsEquipment.component.vue?vue&type=template&id=2b8469f0"
import script from "./informationDetailsEquipment.component.ts?vue&type=script&lang=ts&external"
export * from "./informationDetailsEquipment.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b8469f0')) {
      api.createRecord('2b8469f0', component.options)
    } else {
      api.reload('2b8469f0', component.options)
    }
    module.hot.accept("./informationDetailsEquipment.component.vue?vue&type=template&id=2b8469f0", function () {
      api.rerender('2b8469f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client/informationDetails/informationDetailsEquipment.component.vue"
export default component.exports